import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../interceptor/axiosInstance";
import NotificationService from "../../Utils/NotificationService";

const JoomlaGuide = () => {
  const [orgCode, setOrgCode] = useState('');
  const [copiedScript, setCopiedScript] = useState(false);
  const [copiedDiv, setCopiedDiv] = useState(false);
  const [copiedAll, setCopiedAll] = useState(false);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setOrgCode("YOUR_ORG_CODE");
        return;
      }
      try {
        const response = await axiosInstance.get(`/org/org-details`);
        const data = response.data[0];
        setOrgCode(data.organisation_code);
      } catch (error) {
        console.error('Error fetching organization details:', error);
        setOrgCode("YOUR_ORG_CODE");
      }
    };
    fetchOrgDetails();
  }, []);

  const scriptCode = `<script src="https://ezzdesk.com/shared_prompt.js?code=${orgCode}"></script>`;
  const divCode = `<div id="chat-bot-container"></div>`;
  const fullCode = `${divCode}\n${scriptCode}`;

  const handleCopy = (text, setCopied) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      NotificationService.error('Failed to copy text: ' + err);
    });
  };

  const ImagePlaceholder = () => (
    <div style={{
      width: '100%',
      height: '300px',
      backgroundColor: '#f0f0f0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      margin: '20px 0',
      color: '#999',
      fontSize: '18px'
    }}>
      Image Placeholder
    </div>
  );

  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#ffffff',
      color: '#333',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        Adding Ezzdesk Widget to Joomla 4 Website
      </h1>
      
      <p style={{ fontSize: '16px', marginBottom: '30px', color: '#555' }}>
        Follow this step-by-step guide to add the Ezzdesk widget to your Joomla 4 website. Choose how you want to install your widget below!
      </p>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ fontSize: '22px', marginBottom: '15px' }}>Add Widget to Specific Page</h3>
        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1.</strong> Log in to your Joomla admin panel. Go to <strong>System → Site Templates</strong> and choose the template your website is using:
        </p>
        <img src="/assets/file-hHNJQWSgvI.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
        
        <img src="/assets/file-HhCrovH5wO.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2.</strong> Open the <strong>index.php</strong> file, find the <strong>Body</strong> section, and paste the <strong>script code</strong> below above the closing <code>&lt;/body&gt;</code> tag:
        </p>
        
        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {scriptCode}
          </pre>
          <button
            onClick={() => handleCopy(scriptCode, setCopiedScript)}
            className='btn-color'
            style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
          >
            {copiedScript ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Then click <strong>Save</strong> or <strong>Save & Close</strong> to apply changes:
        </p>
        <img src="/assets/image_f68c8d4a.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <div style={{ background: '#fff3cd', borderLeft: '4px solid #ffecb5', padding: '10px', marginBottom: '15px', fontSize: '14px' }}>
          <strong>Note:</strong> If your <strong>index.php</strong> file doesn’t have the <code>&lt;body&gt;</code> section or tags, check the "Custom Code Fields" section below.
        </div>

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3.</strong> Choose a page for your widget. Click <strong>Content → Articles</strong> in the left menu, and select the page where you'd like to display your widget:
        </p>
        <img src="/assets/file-pWuhQkajY7.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>4.</strong> In the Article editor, click <strong>More → Source Code</strong> icon:
        </p>
        <img src="/assets/file-IQ1Vxq16Q8.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>5.</strong> Select the place on the page where you want the widget to appear and add the <strong>div element</strong> there:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {divCode}
          </pre>
          <button
            onClick={() => handleCopy(divCode, setCopiedDiv)}
            className='btn-color'
            style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
          >
            {copiedDiv ? 'Copied!' : 'Copy'}
          </button>
        </div>

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          After that, click <strong>Ok</strong> in the popup window and save the changes in the top-left corner:
        </p>
        <img src="/assets/image_e5e4926a.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
        <img src="/assets/file-nbz5rVABwu.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ fontSize: '22px', marginBottom: '15px' }}>Add Widget to All Pages</h3>
        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1.</strong> Log in to your Joomla admin panel. Go to <strong>System → Site Templates</strong> and choose the template you're currently using:
        </p>
        <img src="/assets/file-hHNJQWSgvI.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
        
        <img src="/assets/file-HhCrovH5wO.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2.</strong> Open the <strong>index.php</strong> file, find the <strong>Body</strong> section, and paste your <strong>full widget installation code</strong> above the closing <code>&lt;/body&gt;</code> tag. Be sure to save the changes:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {fullCode}
          </pre>
          <button
            onClick={() => handleCopy(fullCode, setCopiedAll)}
            className='btn-color'
            style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
          >
            {copiedAll ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/image_f68c8d4a.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ fontSize: '22px', marginBottom: '15px' }}>Add Widget via Custom Code Fields</h3>
        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Some website themes (like Gantry 5) work with different methods and might not have the <strong>Body</strong> section or the <code>&lt;body&gt;</code> tags. In such cases, templates often have a separate field for custom codes (e.g. <strong>Before &lt;/body&gt;</strong>).
        </p>
          <img src="/assets/Test-Ezzdesk-202.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />
          <img src="/assets/Test-Ezzdesk-2021.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        
        <ul style={{ fontSize: '15px', color: '#666', marginBottom: '10px', paddingLeft: '20px' }}>
          <li style={{ marginBottom: '5px' }}><strong>On all pages:</strong> Just paste the full widget installation code (both the div and script) into this field.</li>
          <li><strong>On a specific page:</strong> Insert the script code into the custom code field and the div element directly onto the page's article source code.</li>
        </ul>
      </div>

      <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', borderLeft: '4px solid #007BFF' }}>
        <h4 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>Need Help?</h4>
        <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>
          If you encounter any issues while installing the widget, feel free to contact our support team.
        </p>
      </div>
    </div>
  );
};

export default JoomlaGuide;
